import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { useAppContext } from "../config/AppContext";
import { getArrayDocDataByRef, queryCollection } from "../models/DataFunctions";
import { useSnackbar } from "notistack";
import { doc } from "firebase/firestore";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { Spin } from "antd";
import Modal1 from "../modals/Modal1";
import Tag from "../tag/Tag";
import TagFilter from "../tag/TagFilter";
import Tippy from "@tippyjs/react";
import SearchBarCarnets from "../textfields/SearchBarCarnets";
import DataGridGPT2 from "../tables/DataGridGPT2";
import DropDownGPT1 from "../dropdowns/DropDownGPT1";
import TabGPT from "../tabs/TabGPT";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import Space from "../layout/Space";
import {
  transformCarnetsToTable,
  transformPartnersToTable,
} from "../models/OrgFunctions";
import { Org } from "../types/org";
import SmallSpinner from "../loading/SmallSpinner";

interface OrgData {
  // Define the expected structure of orgData here
  restrictions?: {
    operator_limited?: boolean;
    conductor_limited?: boolean;
    [key: string]: any;
  };
  [key: string]: any;
}

interface PartnersProps {
  userData: any;
  orgData: OrgData;
  overrideId?: any;
  navigateWorkspace: (path: string) => void;
  workspaceData?: any;
}

function Partners({
  userData,
  orgData,
  overrideId,
  navigateWorkspace,
  workspaceData,
}: PartnersProps) {
  const { currentUser, loading } = useAuth();
  const [tag_open, setTagOpen] = useState(false);
  const { appState, setAppState, filter } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const folders_config = appState.folders_config;
  const saved_data = appState.saved_data;

  const [searchValue, setSearchValue] = useState(
    folders_config?.search_value || ""
  );
  const [rows, setRows] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]>([]);
  const [year, setYear] = useState(null);
  const [loadingRows, setLoadingRows] = useState(true);

  const years = [
    { value: 2024, label: "2024" },
    { value: 2025, label: "2025" },
  ];

  const [tag_folder_id, setTagFolderId] = useState(null);
  const [tag_index, setTagIndex] = useState(1);
  // Function to navigate to a client by ID
  const gotoFolder = (id: any) => {
    navigateWorkspace(`/partner/${id.id}`);
  };

  const gotoNewFolder = () => {
    navigateWorkspace(`/newpartner`);
  };

  // Function to navigate to a client by name
  const gotoFolderName = (option: any) => {
    handleSearchChange(option.label);
    // Find the client with the matching name
  };

  const [update_search, setUpdateSearch] = useState(false);
  const handleSearchChange = async (name: any) => {
    handleSetSeachValue(name);
    setUpdateSearch(true);
  };

  const [tabs = [], setTabs] = useState<any>([]);

  const [allfolders, setAllFolders] = useState([]);
  const tabContent = [<span></span>, <span></span>, <span></span>];
  const [particulier_folders, setParticulierFolders] = useState([]);

  const [masters, setMasters] = useState([]);
  const [only_folder_filter, setOnlyFolderFilter] = useState(
    folders_config?.only_folder_filter || null
  );

  const [activetab, setActiveTab] = useState<string>("all");
  const [partners, setPartners] = useState<Org[]>([]);

  const [searchFolders, setSearchFolders] = useState(
    folders_config?.search_folders || "folders"
  );
  const [tagFilterOpen, setTagFilterOpen] = useState(false);
  const [tag_filters, setTagFilters] = useState([]);

  const [users, setUsers] = useState([]);

  const handleTabChange = (newTab: any) => {
    setActiveTab(newTab);

    const { rows, columns } = transformPartnersToTable(partners, newTab);

    setRows(rows as any);
    setColumns(columns as any);
  };

  const handleSetSeachValue = async (value: any) => {
    setSearchValue(value);
  };
  let newsearchFolders = folders_config?.search_folders || "folders";
  const handleFetchData = async () => {
    if (userData) {
      try {
        // Fetch user data by currentUser's ID

        // Parallel fetching of organization and clients
        const partners = (await queryCollection("org", [
          {
            field: "masters_id",
            operator: "array-contains",
            value: userData.org_id,
          },
        ])) as Org[];

        setTabs([
          {
            label: "Tous",
            id: "all",
          },
          {
            label: "Architectes",
            id: "architect",
          },
          {
            label: "Artisans",
            id: "artisan",
          },
          {
            label: "Constructeurs",
            id: "constructor",
          },
          {
            label: "Promoteurs",
            id: "promotor",
          },
          {
            label: "Maîtres d'oeuvre",
            id: "mdo",
          },
          {
            label: "Dessinateurs",
            id: "drawer",
          },
          {
            label: "Bureaux d'étude",
            id: "expert",
          },
          {
            label: "Infiltromètres",
            id: "infiltro",
          },
          {
            label: "Prospects",
            id: "prospect",
          },
          {
            label: "Autres",
            id: "other",
          },
        ]);

        let tab = "all";

        // if no clients in constructor and one in architect, set active tab to architect

        // Transform clients into table format (rows and columns)
        const { rows, columns } = transformPartnersToTable(partners, tab);

        // Update state if the user data is new or changed
        // Batch state updates to minimize re-renders
        setPartners(partners);
        setRows(rows);
        setColumns(columns);

        // Set search bar options in a single call, filtering only clients with a name
        setOptions(
          partners
            .filter((partner) => partner.name)
            .map((partner) => ({ value: partner.id, label: partner.name }))
        );
        setLoadingRows(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const { enqueueSnackbar } = useSnackbar();

  const [loadingSelection, setLoadingSelection] = useState("");

  useEffect(() => {
    if (saved_data && saved_data.folders) {
      handleFetchData();
    } else {
      if (userData) {
        handleFetchData();
      }
    }
  }, [saved_data, userData]);

  if (loading || !currentUser || !userData || loadingRows) {
    return (
      <div className="h-full w-full pl-4 flex flex-col items-center justify-center gap-2">
        <SmallSpinner />
      </div>
    );
  }

  // Render the client data
  return (
    <div className="flex flex-col h-full w-full pl-4 mr-4">
      <div className="flex flex-row w-full h-full  ">
        <div className="flex flex-col gap-2 h-full w-full max-h-full overflow-auto ">
          <div className="flex flex-row gap-1 ">
            <div className="text-hx font-medium">Partenaires</div>{" "}
            {userData.role === "operator" &&
              orgData.restrictions?.operator_limited && (
                <Tippy
                  content="Vous ne voyez que les dossiers qui vont ont été attribués"
                  delay={500}
                  className="custom-tooltip"
                >
                  <div className="text-hx font-semibold text-neutral-400 ">
                    opérateur
                  </div>
                </Tippy>
              )}
            {userData.role === "conductor" &&
              orgData.restrictions?.conductor_limited && (
                <Tippy
                  content="Vous ne voyez que les dossiers qui vont ont été attribués"
                  delay={500}
                  className="custom-tooltip"
                >
                  <div className="text-hx font-semibold text-neutral-400 ">
                    conducteur
                  </div>
                </Tippy>
              )}
          </div>
          <div className="flex  gap-2 flex-row max-w-c1p2k 2xl:justify-between h-fit">
            {/* Search Bar */}
            <SearchBarCarnets
              orgData={orgData}
              options={options}
              setValue={handleSetSeachValue}
              value={searchValue}
              onAction={gotoFolderName}
              setSeachType={setSearchFolders}
            />
            <div className="flex flex-row gap-2 mr-2 ml-auto">
              <PrimaryButton onClick={gotoNewFolder}>
                <div className="flex flex-row content-center items-center ">
                  <Icon1
                    icon_name="plus"
                    height="16px"
                    width="16px"
                    fill="white"
                  ></Icon1>
                  <Space x={5} />
                  Nouveau partenaire
                </div>
              </PrimaryButton>
            </div>{" "}
          </div>
          {searchValue === "" && (
            <div className="flex flex-row gap-2">
              <div className="ml-0 pl-0 left-0 relative">
                <TabGPT
                  tabs={tabs}
                  activeTab={activetab}
                  setActiveTab={handleTabChange}
                />
              </div>{" "}
            </div>
          )}

          {/* DataGrid displaying the clients */}
          <div className="w-full h-full max-w-c1p2k overflow-y-auto">
            <div
              className={`h-full ${
                overrideId ? "max-h-[70vh]" : "pb-10"
              }  min-h-6`}
            >
              <DataGridGPT2
                selectable={false}
                rows={rows}
                columns={columns}
                searchValue={searchValue || ""}
                onClick={gotoFolder}
                initial_asc={"asc"}
                initialPage={0}
                initialPageSize={100}
                orgData={orgData}
              ></DataGridGPT2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
